import React from "react";

import {ConventionalLids} from "./ConventionalLids";
import {SubFloorLid} from "./SubFloorLid";
import {Plan, Side} from "types";

interface LidElevationViewProps {
    plan: Plan,
    scale: number,
    side: Side,
}

export const LidElevationView: React.FC<LidElevationViewProps> = ({plan, scale, side}) => {
    return plan.lid.type === 'A15' || plan.lid.type === 'B125' || plan.lid.type === 'D400' || plan.lid.type === 'E600'
        ? <ConventionalLids plan={plan} scale={scale} side={side}/>
        : plan.lid.type === 'subfloor'
            ? <SubFloorLid plan={plan} scale={scale} side={side}/>
            : null
}